var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        { attrs: { "max-width": "1000px", persistent: "", value: true } },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("travelService.orderFlight")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("multiple-user-select", {
                                attrs: {
                                  "birth-date-required":
                                    _vm.$store.getters["userProperties"]
                                      .system_settings
                                      .travel_service_flight_insurance ===
                                    _vm.insuranceTypeID.INSURANCE_ADD
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("location-ajax-select", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.departureAirport") +
                                    "*",
                                  placeholder: _vm.$t(
                                    "travelService.enterCountry"
                                  ),
                                  rules: [_vm.validatorIsRequired],
                                  "select-model":
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight
                                      .start_place_id
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "start_place_id",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "start_place_id",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("location-ajax-select", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.arrivalAirport") +
                                    "*",
                                  placeholder: _vm.$t(
                                    "travelService.enterCountry"
                                  ),
                                  rules: [_vm.validatorIsRequired],
                                  "select-model":
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight.end_place_id
                                },
                                on: {
                                  "update:selectModel": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "end_place_id",
                                      $event
                                    )
                                  },
                                  "update:select-model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "end_place_id",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("date-picker", {
                                attrs: {
                                  label:
                                    _vm.$t("travelService.startFlightDate") +
                                    "*",
                                  max:
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight.return_date,
                                  model:
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight.start_date,
                                  rules: [
                                    _vm.validatorIsRequired,
                                    _vm.validatorIsFutureDate
                                  ]
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "start_date",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("time-picker", {
                                attrs: {
                                  label: _vm.$t(
                                    "travelService.startFlightTime"
                                  ),
                                  model:
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight.start_time,
                                  placeholder: _vm.$t("travelService.any"),
                                  "prepend-icon": ""
                                },
                                on: {
                                  "update:model": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "start_time",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.contextModel.travelServiceOrderItemFlight
                              .additionalSegments,
                            function(segment) {
                              return [
                                _c(
                                  "v-layout",
                                  { attrs: { wrap: "" } },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "mb-2 px-2",
                                        attrs: { cols: "12" }
                                      },
                                      [_c("v-divider")],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "px-2",
                                        attrs: { cols: "12", sm: "6" }
                                      },
                                      [
                                        _c("location-ajax-select", {
                                          attrs: {
                                            label:
                                              _vm.$t(
                                                "travelService.departureAirport"
                                              ) + "*",
                                            placeholder: _vm.$t(
                                              "travelService.enterCountry"
                                            ),
                                            rules: [_vm.validatorIsRequired],
                                            "select-model":
                                              segment.start_place_id
                                          },
                                          on: {
                                            "update:selectModel": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                segment,
                                                "start_place_id",
                                                $event
                                              )
                                            },
                                            "update:select-model": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                segment,
                                                "start_place_id",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "px-2",
                                        attrs: { cols: "12", sm: "6" }
                                      },
                                      [
                                        _c("location-ajax-select", {
                                          attrs: {
                                            label:
                                              _vm.$t(
                                                "travelService.arrivalAirport"
                                              ) + "*",
                                            placeholder: _vm.$t(
                                              "travelService.enterCountry"
                                            ),
                                            rules: [_vm.validatorIsRequired],
                                            "select-model": segment.end_place_id
                                          },
                                          on: {
                                            "update:selectModel": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                segment,
                                                "end_place_id",
                                                $event
                                              )
                                            },
                                            "update:select-model": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                segment,
                                                "end_place_id",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "px-2",
                                        attrs: { cols: "12", sm: "6" }
                                      },
                                      [
                                        _c("date-picker", {
                                          attrs: {
                                            label:
                                              _vm.$t(
                                                "travelService.startFlightDate"
                                              ) + "*",
                                            model: segment.start_date,
                                            rules: [
                                              _vm.validatorIsRequired,
                                              _vm.validatorIsFutureDate
                                            ]
                                          },
                                          on: {
                                            "update:model": function($event) {
                                              return _vm.$set(
                                                segment,
                                                "start_date",
                                                $event
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "px-2",
                                        attrs: { cols: "12", sm: "6" }
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c("time-picker", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "travelService.startFlightTime"
                                                ),
                                                model: segment.start_time,
                                                placeholder: _vm.$t(
                                                  "travelService.any"
                                                ),
                                                "prepend-icon": ""
                                              },
                                              on: {
                                                "update:model": function(
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    segment,
                                                    "start_time",
                                                    $event
                                                  )
                                                }
                                              }
                                            }),
                                            _c(
                                              "v-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeSegment(
                                                      segment
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "travelService.removeSegment"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    "v-slide-x-transition",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.isReturnRoute,
                                              expression: "!isReturnRoute"
                                            }
                                          ],
                                          staticClass: "primary",
                                          on: { click: _vm.addSegment }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("travelService.addSegment")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-slide-x-transition",
                                    [
                                      _c("v-checkbox", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.contextModel
                                                .travelServiceOrderItemFlight
                                                .additionalSegments.length ===
                                              0,
                                            expression:
                                              "contextModel.travelServiceOrderItemFlight.additionalSegments.length === 0"
                                          }
                                        ],
                                        attrs: {
                                          label: _vm.$t(
                                            "travelService.isReturnRoute"
                                          )
                                        },
                                        model: {
                                          value: _vm.isReturnRoute,
                                          callback: function($$v) {
                                            _vm.isReturnRoute = $$v
                                          },
                                          expression: "isReturnRoute"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Priority boarding/Fast track"
                                },
                                model: {
                                  value:
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight
                                      .is_priority_boarding,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "is_priority_boarding",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemFlight.is_priority_boarding"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.isReturnRoute === true
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "12", sm: "6" }
                                },
                                [
                                  _c("date-picker", {
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "travelService.returnFlightDate"
                                        ) + "*",
                                      min:
                                        _vm.contextModel
                                          .travelServiceOrderItemFlight
                                          .start_date,
                                      model:
                                        _vm.contextModel
                                          .travelServiceOrderItemFlight
                                          .return_date,
                                      rules: [
                                        _vm.validatorIsRequired,
                                        _vm.validatorIsFutureDate
                                      ]
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextModel
                                            .travelServiceOrderItemFlight,
                                          "return_date",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isReturnRoute === true
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "12", sm: "6" }
                                },
                                [
                                  _c("time-picker", {
                                    attrs: {
                                      label: _vm.$t(
                                        "travelService.returnFlightTime"
                                      ),
                                      model:
                                        _vm.contextModel
                                          .travelServiceOrderItemFlight
                                          .return_time,
                                      placeholder: _vm.$t("travelService.any"),
                                      "prepend-icon": ""
                                    },
                                    on: {
                                      "update:model": function($event) {
                                        return _vm.$set(
                                          _vm.contextModel
                                            .travelServiceOrderItemFlight,
                                          "return_time",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.availableClasses,
                                  label: _vm.$t("travelService.class") + "*",
                                  rules: [_vm.validatorIsRequired]
                                },
                                model: {
                                  value:
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight.seat_class,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "seat_class",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemFlight.seat_class"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("travelService.preferredSeat"),
                                  placeholder: _vm.$t("global.anyV2")
                                },
                                model: {
                                  value:
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight
                                      .preferred_seat,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "preferred_seat",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemFlight.preferred_seat"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.$t(
                                    "travelService.registeredBaggageWillBeAssigned"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight.is_baggage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "is_baggage",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemFlight.is_baggage"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.$t(
                                    "travelService.additionalServices"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.contextModel
                                      .travelServiceOrderItemFlight
                                      .is_additional_services,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contextModel
                                        .travelServiceOrderItemFlight,
                                      "is_additional_services",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contextModel.travelServiceOrderItemFlight.is_additional_services"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.contextModel.travelServiceOrderItemFlight
                            .is_additional_services
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "px-2",
                                  attrs: { cols: "12", sm: "6" }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t(
                                        "travelService.additionalServicesDetails"
                                      ),
                                      placeholder: _vm.$t(
                                        "travelService.additionalServicesPlaceholder"
                                      ),
                                      rules: [_vm.validatorIsRequired]
                                    },
                                    model: {
                                      value:
                                        _vm.contextModel
                                          .travelServiceOrderItemFlight
                                          .additional_services,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contextModel
                                            .travelServiceOrderItemFlight,
                                          "additional_services",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "contextModel.travelServiceOrderItemFlight.additional_services"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-2",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("cost-centre-select", {
                                attrs: { value: _vm.contextModel.cost_centre },
                                on: {
                                  "update:value": function($event) {
                                    return _vm.$set(
                                      _vm.contextModel,
                                      "cost_centre",
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "px-2", attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: _vm.$t("global.comment") },
                                model: {
                                  value: _vm.contextModel.comment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.contextModel, "comment", $$v)
                                  },
                                  expression: "contextModel.comment"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.formValid,
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v("Ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }